import { defineStore } from "pinia";
import { privateBoaHttp } from "@/boa-api-client";
import { useAwardStore } from ".";
import type { DynamicTemplate } from "best-of-awards-api";

type State = {
  templates: any;
};

export default defineStore("sendgrid", {
  state: (): State => ({
    templates: [],
  }),
  getters: {},
  actions: {
    async getTemplates() {
      try {
        const awardStore = useAwardStore();
        const response = await privateBoaHttp
          .get("sendgrid-templates")
          .json<Array<DynamicTemplate>>();
        return response.filter((t) =>
          t.name.startsWith(awardStore.activeAward.settings?.code || "")
        );
      } catch (error) {
        console.error((error as any).message);
      }
    },
    async getTemplate(templateId: string) {
      try {
        const response = await privateBoaHttp
          .get(`sendgrid-templates/${templateId}`)
          .json<DynamicTemplate>();
        return response;
      } catch (error) {
        console.error((error as any).message);
      }
    },
    clear() {
      this.$reset();
    },
  },
});
